import {} from 'react';
import useImageAssets from '../useImageAssets';
import type { UnionImage } from '~/graphql/types';
import getUnionImageUrl from '~/util/getUnionImageUrl';

const useUnionImageUrl = ({
  image,
  defaultImage,
}: {
  image: UnionImage | null | undefined;
  defaultImage: string | null;
}): string | null => {
  const assetImages = useImageAssets();
  return getUnionImageUrl(image, assetImages, defaultImage);
};

export default useUnionImageUrl;
